var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StateRenderer',_vm._b({attrs:{"lines":_vm.lines}},'StateRenderer',_vm.periodsState,false),[_vm._t("default",null,null,_vm.periodsState)],2)}
var staticRenderFns = []

export { render, staticRenderFns }